/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const Divider = ({ className }) => {
  return (
    <svg
      className={`divider ${className}`}
      fill="none"
      height="48"
      viewBox="0 0 2 48"
      width="2"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path className="path" d="M1 0L1 48" stroke="#D9DBE9" strokeWidth="2" />
    </svg>
  );
};
